// extracted by mini-css-extract-plugin
module.exports = {"tileMenuItem":"tile-menu-module--tileMenuItem--2MDkj","tileMenuTitle":"tile-menu-module--tileMenuTitle--2kE4m","tileMenuImage":"tile-menu-module--tileMenuImage--16IOM"};